import React from 'react';
import { FacilityKey, getFacilitySponsors } from '../data/sponsors';

interface FacilitySponsorBannerProps {
  facility: FacilityKey;
}

const FacilitySponsorBanner: React.FC<FacilitySponsorBannerProps> = ({ facility }) => {
  const facilitySponsors = getFacilitySponsors(facility);

  if (facilitySponsors.length === 0) {
    return null;
  }

  return (
    <div className="facility-sponsor-banner">
      <p className="facility-sponsor-label">Proudly sponsored by</p>
      <div className="facility-sponsor-logos">
        {facilitySponsors.map((sponsor) => {
          const mark = sponsor.logo ? (
            <img
              src={sponsor.logo}
              alt={sponsor.name}
              className={`facility-sponsor-logo${sponsor.logoClass ? ` ${sponsor.logoClass}` : ''}`}
            />
          ) : (
            <span className="facility-sponsor-name">{sponsor.name}</span>
          );

          return sponsor.website ? (
            <a
              key={sponsor.id}
              href={sponsor.website}
              target="_blank"
              rel="noopener noreferrer"
              className="facility-sponsor-link"
              aria-label={`${sponsor.name} website`}
            >
              {mark}
            </a>
          ) : (
            <div key={sponsor.id} className="facility-sponsor-link">
              {mark}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FacilitySponsorBanner;
